import React from 'react'
import styled from '@emotion/styled'
import { Container } from 'components/layout'
import { Term } from 'services/ContentfulService/models/term'
import { Breadcrumbs } from 'components/elements/Breadcrumbs'
import { colors } from 'parameters/ui'
import { RichTextArea } from 'experiences/shared/RichTextArea'
import { TopicsSection } from 'experiences/learn/topics/TopicsSection'
import { CarouselItem, CarouselItems, ProductsSection } from 'experiences/learn/products/Section'
import { buildTermBreadcrumbs } from '../utils'
import { mediaQueriesByDevice } from 'parameters/viewport'
import { Stack } from 'components/layout/primitives'

export interface GlossaryTermProps {
	term: Term
}

export const GlossaryTermPage: React.FC<React.PropsWithChildren<GlossaryTermProps>> = ({ term }) => {
	const breadcrumbs = buildTermBreadcrumbs(term)

	return (
		<Container>
			<Breadcrumbs breadcrumbs={breadcrumbs} />
			<Title>{term.name}</Title>
			<Divider />
			<StackWithOverrides>
				<Flexbox>
					<RichTextArea document={term.definition} maxWidth={857} />
				</Flexbox>
				<TopicsSection title="Related Topics" topics={term.relatedTopics || []} />
				<ProductsSection title="Related Products" products={term.products} />
			</StackWithOverrides>
		</Container>
	)
}

const Title = styled.h1`
	margin-top: 32px;
`

const Divider = styled.div`
	height: 1px;
	background: ${colors.secondaryLightGrey1};
	margin: 40px 0;
	${mediaQueriesByDevice.tablet} {
		margin: 20px 0;
	}
`

const Flexbox = styled.div`
	display: flex;
`

/**
 * Stops justifying content
 */
const StackWithOverrides = styled(Stack)`
	${CarouselItems} {
		justify-content: left;
	}
	${CarouselItem} {
		@media screen and (max-width: 560px) {
			width: 190px;
			height: 160px;
		}
	}
`
